import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
// import { theme } from '../../../themes/theme';

const NavigationButton = styled(({ ...props }: any) => (
    <Button {...props} />
))(({ theme, label }) => ({
    minWidth: 0,
    minHeight: 0,
    fontSize: '32px',
    fontWeight: 600,
    background: 'transparent',
    color: theme.custom.navigationSvgIconColor,
    border: "1px solid transparent",
    borderRadius: '100%',
    height: "40px",
    ":hover": {
        border: "1px solid black",
        color: "black",
    },
}));

export default NavigationButton;
